<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item>异动老师看板</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="90" :show-message="false" label-position="right">
        <Row :gutter="24">
          <Col :span="6">
            <Form-item label="学员">
              <Input placeholder="学员ID/姓名" name="uid" v-model="queryParam.uid"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="班主任">
              <admin-user-select :status="1" adminGroupCode="userStudyAdviser"
                                 :disabled="isStudyAdviser"
                                 v-model="queryParam.studyAdviserId"></admin-user-select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="当前外教">
              <Input placeholder="外教ID/姓名" name="tchName" v-model="queryParam.tchName"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="统计窗口">
              <Date-picker type="daterange" format="yyyy-MM-dd" v-model="dateRange"
                           placement="bottom-start" placeholder="请选择统计窗口"
                           :options="{ disabledDate: disabledDate }"
                           style="width: 100%" @on-change="onDateRangeChange"></Date-picker>
            </Form-item>
          </Col>
        </Row>
        <Row>
          <Col :span="6">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                    @click="search">搜索</Button>
            <Button type="primary" :loading="exportLoading" :disable="exportLoading" style="margin-left: 8px"
                    @click="exportData">导出</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/user/tch-rebind/list"
          :params="queryParam" :onLoading="onLoading"></List>
  </div>
</template>
<script>
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
export default {
  name: 'TchRebindBoard',
  data () {
    let now = this.$moment()
    let startDate = '2025-09-01'
    let endDate = now.format('YYYY-MM-DD')
    return {
      searchLoading: false,
      exportLoading: false,
      reload: 0,
      rankScoreSeq: 0,
      rankScoreMap: {},
      isStudyAdviser: Number(this.$store.get('adminRule')) === 2,
      dateRange: [startDate, endDate],
      queryParam: {
        uid: '',
        studyAdviserId: null,
        tchName: '',
        startDate: startDate,
        endDate: endDate
      },
      title: [
        {
          title: '学员ID',
          key: 'uid',
          width: 100,
          align: 'center',
          fixed: 'left'
        },
        {
          title: '学员姓名',
          key: 'userName',
          width: 120
        },
        {
          title: '班主任',
          key: 'adviserName',
          width: 110,
          align: 'center'
        },
        {
          title: '首次绑定外教',
          key: 'firstTchName',
          width: 180,
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: row.firstTchName,
              score: row.monthRankScoreFirst
            })
          }
        },
        {
          title: '外教变更完整链路',
          width: 280,
          render: (h, params) => this.renderTchChain(h, params.row.tchChain, params.row.tchResignFlags, params.row.tchChainIds)
        },
        {
          title: '本年更换过的外教总人数',
          key: 'tchChangeCount',
          width: 130,
          align: 'center'
        },
        {
          title: '历次换绑时间',
          width: 220,
          render: (h, params) => this.renderChangeDates(h, params.row.changeDates)
        },
        {
          title: '当前绑定外教',
          width: 180,
          render: (h, params) => this.renderCurrentTch(h, params.row)
        },
        {
          title: '本年上课总课时',
          key: 'yearLessonCount',
          width: 120,
          align: 'center'
        },
        {
          title: '备注',
          width: 220,
          render: (h, params) => this.renderLongText(h, params.row.remark)
        }
      ]
    }
  },
  created: function () {
    if (this.isStudyAdviser) {
      this.queryParam.studyAdviserId = parseInt(this.$store.get('id'))
    }
  },
  methods: {
    renderLongText (h, text) {
      let value = text === undefined || text === null ? '' : String(text)
      if (!value) {
        return h('span', '')
      }
      return h('div', {
        attrs: {
          title: value
        },
        style: {
          whiteSpace: 'normal',
          wordBreak: 'break-all',
          lineHeight: '18px',
          textAlign: 'left'
        }
      }, value)
    },
    renderTchChain (h, chain, flags, ids) {
      let chainValue = chain === undefined || chain === null ? '' : String(chain)
      if (!chainValue) {
        return h('span', '')
      }
      let flagsValue = flags === undefined || flags === null ? '' : String(flags)
      let idsValue = ids === undefined || ids === null ? '' : String(ids)
      let names = chainValue.split(' → ')
      let flagList = flagsValue ? flagsValue.split(',') : []
      let idList = idsValue ? idsValue.split(',') : []
      // 段数对不上时整段按纯文本显示
      if (names.length !== flagList.length) {
        return this.renderLongText(h, chainValue)
      }
      let scoreMap = this.rankScoreMap || {}
      let children = []
      names.forEach((name, index) => {
        if (index > 0) {
          children.push(' → ')
        }
        let tid = idList[index] != null ? String(idList[index]).trim() : ''
        let score = tid ? (scoreMap[tid] != null ? scoreMap[tid] : scoreMap[Number(tid)]) : null
        let node = renderTchNameWithScore(h, { text: name, score: score })
        if (String(flagList[index]).trim() === '1') {
          children.push(h('span', { style: { color: 'red' } }, [node]))
        } else {
          children.push(node)
        }
      })
      return h('div', {
        attrs: {
          title: chainValue
        },
        style: {
          whiteSpace: 'normal',
          wordBreak: 'break-all',
          lineHeight: '18px',
          textAlign: 'left'
        }
      }, children)
    },
    renderCurrentTch (h, row) {
      row = row || {}
      let text = row.currentTchName === undefined || row.currentTchName === null ? '' : String(row.currentTchName)
      if (!text) {
        return h('span', '')
      }
      let idsValue = row.currentTchIds === undefined || row.currentTchIds === null ? '' : String(row.currentTchIds)
      let names = text.split('、')
      let idList = idsValue ? idsValue.split(',') : []
      let scoreMap = this.rankScoreMap || {}
      if (!idList.length || idList.length !== names.length) {
        // 无法对齐 ID 时：若仅一人且有 first/current 单 ID 则不瞎猜，退回纯文案
        return this.renderLongText(h, text)
      }
      let children = []
      names.forEach((name, index) => {
        if (index > 0) {
          children.push('、')
        }
        let tid = String(idList[index]).trim()
        let score = scoreMap[tid] != null ? scoreMap[tid] : scoreMap[Number(tid)]
        children.push(renderTchNameWithScore(h, { text: name, score: score }))
      })
      return h('div', {
        attrs: { title: text },
        style: {
          whiteSpace: 'normal',
          wordBreak: 'break-all',
          lineHeight: '18px',
          textAlign: 'left'
        }
      }, children)
    },
    renderChangeDates (h, text) {
      let value = text === undefined || text === null ? '' : String(text)
      if (!value) {
        return h('span', '')
      }
      return h('Poptip', {
        props: {
          trigger: 'click',
          placement: 'top',
          transfer: true
        }
      }, [
        h('span', {
          style: {
            display: 'inline-block',
            maxWidth: '190px',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            verticalAlign: 'middle',
            cursor: 'pointer'
          }
        }, value),
        h('div', {
          slot: 'content',
          style: {
            maxWidth: '360px',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            textAlign: 'left'
          }
        }, value)
      ])
    },
    disabledDate (date) {
      // 统计窗口不早于 2025-09-01
      return date && date.valueOf() < this.$moment('2025-09-01').valueOf()
    },
    onDateRangeChange (value) {
      if (value && value.length === 2) {
        this.queryParam.startDate = value[0] || ''
        this.queryParam.endDate = value[1] || ''
        return
      }
      this.queryParam.startDate = ''
      this.queryParam.endDate = ''
    },
    search () {
      this.reload = new Date().getTime()
    },
    onLoading (loading) {
      this.searchLoading = loading
      if (!loading) {
        this.loadMonthRankScores()
      }
    },
    loadMonthRankScores () {
      const table = this.$refs.dataList && this.$refs.dataList.tableData
      if (!table || !table.length) {
        this.rankScoreMap = {}
        return
      }
      const ids = []
      table.forEach(function (row) {
        if (row.firstTchId != null) {
          ids.push(row.firstTchId)
        }
        String(row.tchChainIds || '').split(',').forEach(function (id) {
          id = String(id).trim()
          if (id) { ids.push(id) }
        })
        String(row.currentTchIds || '').split(',').forEach(function (id) {
          id = String(id).trim()
          if (id) { ids.push(id) }
        })
      })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        self.rankScoreMap = map || {}
        table.forEach(function (row) {
          let score = map[row.firstTchId]
          if (score == null) {
            score = map[String(row.firstTchId)]
          }
          self.$set(row, 'monthRankScoreFirst', score == null ? null : score)
        })
      })
    },
    exportData () {
      this.exportLoading = true
      this.$http({
        method: 'post',
        url: '/user/tch-rebind/list-export',
        data: this.queryParam,
        responseType: 'arraybuffer'
      }).then((response) => {
        if (response.data) {
          let blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'})
          let link = document.createElement('a')
          link.target = '_blank'
          link.href = window.URL.createObjectURL(blob)
          link.download = '外教换绑学员汇总.xlsx'
          link.click()
          this.exportLoading = false
        } else {
          this.$Message.error(response.msg || '导出失败')
          this.exportLoading = false
        }
      }).catch(() => {
        this.$Message.error('导出失败')
        this.exportLoading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// TchRebindBoard.vue?51f04ba4